export enum CellDataType {
  String = 0,
  Number = 1,
  Date = 2,
  Phone = 3,
  Email = 4,
  Custom = 5,
  Boolean = 6,
}
